import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { SxProps, Theme, useTheme } from '@mui/material';
import { CustomColor, VariantColor } from '@/types';
import Icon from './Icon.component';

interface IconContainerProps {
  icon: IconProp;
  color?: CustomColor;
  variantColor?: VariantColor;
  size?: number | string;
  sx?: SxProps<Theme>;
}

const IconContainer = function ({
  icon,
  color,
  variantColor = 'main',
  size = 16,
  sx,
}: IconContainerProps): JSX.Element {
  const theme = useTheme();

  const getStringColor = (colorPassed?: CustomColor): string => {
    if (!colorPassed) return theme.palette.primary.main;

    return theme.palette[colorPassed][variantColor];
  };

  return <Icon icon={icon} color={getStringColor(color)} size={size} sx={sx} />;
};

export default IconContainer;
